import { HttpResourceRef } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IApiErrorResponse } from '@core/models/api-response.model';
import { IUserAssignableRole } from '@core/models/user-role.model';
import { ApiService } from '@core/services/api/api.service';
import { Console } from './logger.service';

/** Recupera i ruoli che possono essere associati a un utente. */
@Injectable({
  providedIn: 'root'
})
export class UsersRulesService {
  private readonly logLabel = 'UsersRulesService';
  private readonly apiService = inject(ApiService);

  /** Resource reattiva dei ruoli utente disponibili. */
  createUserRolesResource(shouldLoad: () => boolean): HttpResourceRef<IUserAssignableRole[]> {
    return this.apiService.getResource<IUserAssignableRole[]>(
      () => (shouldLoad() ? 'tipo/ruoli-utente' : undefined),
      undefined,
      { defaultValue: [], debugName: 'userAssignableRoles' }
    );
  }

  /** Recupera una tantum l'elenco dei ruoli associabili a un utente. */
  getUserRoles(): Observable<IUserAssignableRole[]> {
    const logPrefix = `${this.logLabel}.getUserRoles() `;

    return this.apiService.get<IUserAssignableRole[]>('tipo/ruoli-utente').pipe(
      catchError((error: IApiErrorResponse) => {
        Console.log(
          logPrefix + (error?.message || 'Errore nel recupero dei ruoli associabili agli utenti.'),
          error,
          'err'
        );
        return throwError(() => error);
      })
    );
  }
}
